import { Component, Vue } from "vue-property-decorator";

import { Loading, Nav } from "@/components";
import { Announcement } from "@/constant/Announcement";
import { AnnouncementModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";

import { Priv } from "@/util/Priv";

@Component<AnnouncementContController>({
  components: {
    Loading,
    Nav
  }
})
export default class AnnouncementContController extends Vue {
  private isLoading = true;

  private expireTime = 0;  
  private targetMap = Announcement.TargetMap;
  private announcementInfo = TCBReceiptApi.Protobuf.Announcement.create();
  private attachmentList: {
    type: number;
    src: string;
    originName: string;
    name: string;
  }[] = [];

  public async created() {
    /* 取得最新的權限map並判斷有何權限 */
    await this.setPriv();
    /* 取得最新的權限map並判斷有何權限 */

    this.isLoading = true;
    
    const item = TCBReceiptApi.Protobuf.Announcement.create({
      announcementId: parseInt(this.$route.query.id as string)
    });

    const announcementQuery = TCBReceiptApi.Protobuf.Announcement.encode(item).finish();
    await AnnouncementModel.getAnnouncementByAnnouncementID(announcementQuery);
    this.announcementInfo = AnnouncementModel.getSpecificAnnouncement();
    this.convertAttachmentList();

    console.log("api data");
    console.log(this.announcementInfo);

    this.isLoading = false;
  }

  private convertAttachmentList() {
    const filePath = `${process.env.VUE_APP_PUBLIC_BASE_URL}/`;
    this.announcementInfo.attachmentList.forEach(attachment => {
      const item = {
        type: attachment.type as number,
        src: filePath + attachment.name,
        originName: attachment.originName as string,
        name: attachment.name as string
      };
      this.attachmentList.push(item);
    });
  }

  private downloadFile(index: number) {
    const attachment = this.attachmentList[index] as {
        type: number,
        src: string,
        originName: string,
        name: string,
    };
    console.log(attachment);

    const dataType = "release";
    const id = parseInt(this.$route.query.id as string);
    const name = attachment.name as string;
    const queryString = "data_type="+dataType+"&id="+id.toString()+"&name="+name;
    console.log(queryString);
    AnnouncementModel.downloadFile(queryString);
  }

  /* 取得最新的權限map並判斷有何權限 */
  private async setPriv() {
    await Priv._checkPriv();
    this.expireTime = Priv._getExpireTime();
  }
  /* 取得最新的權限map並判斷有何權限 */
}
